import API from "@/models/API";

export default class Debts {
    constructor(item = {}) {}

    static get = (query,filters) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/store-debts/monthly-analysis${query}${filters}`);

    static getMonthlyPoints = (query,filters) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/store-debts/monthly-points${query}${filters}`);

    static getRedemptionInvoice = (query,filters) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/store-debts/monthly-analysis-redemption${query}${filters}`);

    static getExportedMonthlyInvoicingStatus = () =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-store-points-debt`
        );

    static exportMonthlyInvoicing = item =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-store-points-debt`,
            item
        );

    static deleteExportedMonthlyInvoicing = id =>
        API.delete(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-store-points-debt/${id}`
        );

    static getExportedMonthlyPointsStatus = () =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-store-points`
        );
        
    static exportMonthlyPoints = item =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-store-points`,
            item
        );

    static deleteExportedMonthlyPoints = id =>
        API.delete(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-store-points/${id}`
        );

    static getExportedRedemptionInvoicingStatus = () =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-store-redemption-debt`
        );

    static exportRedemptionInvoicing = item =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-store-redemption-debt`,
            item
        );

    static deleteExportedRedemptionInvoicing = id =>
        API.delete(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-store-redemption-debt/${id}`
        );

    static getSmsMetrics = (date) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/sms-metrics?date=${date}`);

    static getViberMetrics = (date) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/viber-metrics?date=${date}`);
}
